import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { InfluencerPayoutMarginSchema } from '../../../../../../../schemas/ProjectManager/MarginSchema'
import axiosService from '../../../../../../../utils/AxiosService'
import { currencyFormat } from '../../../../../../../utils/Helper'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function InfluencerPayoutMarginColumn({ campaignScenario, actionGroup, actions }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { campaign, primaryScenarioId } = useContext(CampaignContext)
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeMargin = influencer_payout_margin => {
    if(currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitMargin(influencer_payout_margin), 1000))
  }

  const submitMargin = influencer_payout_margin => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/campaign_scenario_action_groups/${actionGroup.id}`, { campaign_scenario_action_group: { influencer_payout_margin }})
    .then((updatedActionGroup) => {
      toastSuccess('Margin updated')
      actionGroup.influencer_payout_margin = updatedActionGroup.influencer_payout_margin
      campaignScenario.actions.filter(action => action.campaign_scenario_action_group_id === actionGroup.id).forEach(action => action.influencer_payout_margin = updatedActionGroup.influencer_payout_margin)
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  const influencerPayoutMarginPrice = useMemo(() => actions.reduce((result, action) => result + action.influencerPayoutMarginPrice, 0))

  return (
    <div className="col-span-2 p-2 flex justify-between items-center border-r-2 border-border-primary dark:border-rb-dark-mode-lighter">
      <div>
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Inf. Payout Margin</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(influencerPayoutMarginPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <Formik
        key={actionGroup.influencer_payout_margin}
        initialValues={{ influencer_payout_margin: actionGroup.influencer_payout_margin }}
        validationSchema={InfluencerPayoutMarginSchema}
        onSubmit={changeMargin}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form className="w-2/5">
            <div className="relative -mt-2">
              <Input
                disabled={readOnly}
                addon="%"
                addonPosition="end"
                error={touched.influencer_payout_margin && errors.influencer_payout_margin}
                name="influencer_payout_margin"
                noLabelPadding
                onChange={(e) => {
                  changeMargin(e.target.value)
                  handleChange(e)
                }}
                onBlur={handleBlur}
                value={values.influencer_payout_margin}
                overrideClassName="h-7"
                topMargin="mt-1"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})